import {Component, OnInit, Input} from 'ng-metadata/core';
import {GetItRequestService} from './getItRequest.service';
import { FormBuilderEnums } from '../../../../infra/formBuilder/formBuilder.service';
import { NgrsService } from '../ngrs.service';
import { PhysicalBestOfferService } from '../physicalBestOffer/physicalBestOffer.service';
import { UserSessionManagerService } from '../../../../security/userSessionManager.service';
import {ALERT_MSG_TYPE, AlertFactory} from "../../../../infra/widgets/alerts/alertFactory.service";

const get= require('lodash/get');

@Component({
    "inputs":['getitformopen'],
    selector: 'prm-get-it-request',
    templateUrl: 'components/search/fullView/ngrs/getItRequest/getItRequest.html',
})

export class PrmGetItRequest implements OnInit{

    @Input() item:Object;    
    @Input() bestoffer:Object;
    private _getItFormOpen: Object;
          
    constructor(private getItRequestService: GetItRequestService,
        private ngrsService: NgrsService,
        private userSessionManagerService : UserSessionManagerService,
        private physicalBestOfferService: PhysicalBestOfferService) {
            this._getItFormOpen = this.getitformopen;
            this._bestOffer=this.bestoffer;
           
    }

    ngOnInit() {

    }

    private _showSuceesBar: boolean=false;
    private _locations = ["1", "2", "3", "4"];
    private _selectedLocation = "1";
    private _dateField = {name: 'dateNgrs', label:'',uiType: FormBuilderEnums.UI_TYPE.DATE_NOT_NEEDED_AFTER};
    private _volumeField = { name: 'myVolume', label:'citationLinker.volume', uiType: FormBuilderEnums.UI_TYPE.TEXT};
    private _noteField = { name: 'myNote', label:'nui.deposit.note', uiType: FormBuilderEnums.UI_TYPE.TEXT};
    private _locationField = { name: 'myLocation', label:'request.photocopies.pickup_location_name', uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,mandatory:true};

    private _formData: Object = {};

    public get volumeField() {
        return this._volumeField;
    }

    public get noteField() {
        return this._noteField;
    }

    public get locationField() {
        return this._locationField;
    }

    public get selectedLocation() {
        return this._selectedLocation;
    }
    public set selectedLocation(value) {
        this._selectedLocation = value;
    }

    public get dateField() {
        return this._dateField;
    }
    public set dateField(value) {
        this._dateField = value;
    }    
    
    public get locations() {
        return this._locations;
    }
    public set locations(value) {
        this._locations = value;
    }

    public get formData() {
        return this._formData;
    }
    public set formData(value) {
        this._formData = value;
    }    

    public clearForm(){
        this.formData = {};

    }

    public cancelForm(){
        this._getItFormOpen={getItFormOpen:false};
        this.getitformopen.getItFormOpen=false;
        this.clearForm();
    }

    public submitForm(){
        this.physicalBestOfferService.createBorrowingRequest(this._formData.myNote,this._formData.myLocation,this._formData.dateNgrs,this.item, this.bestoffer);
        this._showSuceesBar=true;           
        this._getItFormOpen={getItFormOpen:false};
        this.getitformopen.getItFormOpen=false;     
    }   

    public isSignedIn() {
        return !this.userSessionManagerService.isGuest();
    }

    public getSignInLink(){
        return this.ngrsService.signInLinkRequest;
    } 
    
    public isRequestSuccesed():boolean{
        return true;
    }

    public showSuceesBar():boolean{
        return this._showSuceesBar;
    }

    public getResponseMessage():String{
        return "my message";
    }
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/getItRequest/getItRequest.directive.ts